import SkillLogo from '../../../../styles/images/skill.svg';
import ClappingImage from '../../../../styles/images/clapping.svg';
import { CircularProgressbar, buildStyles } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';
import { useNavigate } from 'react-router-dom';
import PopUpImg from '../../../../styles/images/pop-img.png';
import { useEffect, useState, useContext } from 'react';
import SessionContext from '../../../../library/Core/SessionContext';

const AlumniSkillLayout = (props: any) => {
    const { sessionState } = useContext(SessionContext);
    const userStatusCode = sessionState?.userStatusCode;
    const userTypeCode = sessionState?.userTypeCode;
    const profileStatusCode = sessionState?.profileStatusCode; 
    const isInternalHeaderActive = userTypeCode != 'SUPER_ADMIN' && userTypeCode != 'INSTITUTE_ADMIN' && userStatusCode != 'ACTIVE' && profileStatusCode != 'basic-info-complete' && profileStatusCode != 'COMPLETE'

    // const [userStatusCode, setUserStatusCode] = useState(sessionStorage.getItem('user-status-code'));
    const [SchoolLogo, setSchoolLogo] = useState('');

    //const userStatusCode = sessionStorage.getItem('user-status-code');
    var stepMessage: any = sessionStorage.getItem('step-message');

    useEffect(() => {
        let SchoolLogo = sessionStorage.getItem('school-image') as any;
        setSchoolLogo(SchoolLogo);
        // setUserStatusCode(sessionStorage.getItem('user-status-code'));
    }, []);

    const [profilePercentage, setprofilePercentage] = useState<any>('');
    useEffect(() => {
        const profilePercentage = sessionStorage.getItem('profile-percentage') ? sessionStorage.getItem('profile-percentage') : 0;
        setprofilePercentage(profilePercentage);
    }, [sessionStorage.getItem('profile-percentage')]);

    const navigate = useNavigate();
    return (
        <>
            <div className="main-wrap">
                <div className="leftPane">
                    <div className="leftPaneWrap">
                        {isInternalHeaderActive && (
                            <div className="leftPaneHeaderWrap">
                                <div className="leftPaneHeader">
                                    <img src={SchoolLogo} alt="" />
                                    <label className="user_name">
                                        Hey <span>{`${sessionState?.firstName} ${sessionState?.lastName}`}</span>
                                    </label>
                                </div>
                                {/* {(profilePercentage != 0 || (stepMessage !== null && stepMessage !== '')) && (
                                    <div className="global bg_transparant show" data-pai="75">
                                        {stepMessage !== null && stepMessage !== '' && (
                                            <div
                                                className={profilePercentage != 0 ? 'unlock green_recom_bg_left' : 'unlock green_recom_bg'}>
                                                <div className="img">
                                                    <img src={ClappingImage} alt="" />
                                                </div>
                                                <div className="text">{stepMessage}</div>
                                            </div>
                                        )}
                                        {profilePercentage != 0 && (
                                            <div className="progress_svg">
                                                <CircularProgressbar
                                                    value={profilePercentage}
                                                    text={`${profilePercentage}%`}
                                                    styles={buildStyles({
                                                        // This is in units relative to the 100x100px
                                                        // SVG viewbox.
                                                        textSize: '25px',
                                                        //   pathColor: `rgba(62, 152, 199, ${profilePercentage / 100})`,
                                                        textColor: '#000',
                                                        //   trailColor: '#d6d6d6',
                                                    })}
                                                />
                                            </div>
                                        )}
                                    </div>
                                )} */}
                            </div>
                        )}
                        <div className="leftPaneBodyWrap">
                            <div className="leftPaneBody">
                                <div className="qs_body aos-init aos-animate" data-aos="fade-right" data-nextpage="undergraduate.html">
                                    <div>{props.children}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="rightPane basic-information">
                    <div className="rightPaneWrap">
                        {isInternalHeaderActive && (
                            <div className="rightPaneHeaderWrap">
                                <div className="rightPaneHeader">
                                    <label className="user_name">
                                        Hey <span>{`${sessionState?.firstName} ${sessionState?.lastName}`}</span>
                                    </label>
                                </div>
                            </div>
                        )}
                        <div className="rightPaneBodyWrap">
                            <div className="rightPaneBody">
                                <div className="step step_1">
                                    <h2 className="stepHeader">How Your Skills Add Value?</h2>
                                    <div className="listed_points">
                                        <ul className="">
                                            <li>Match with Alumni having similar skills</li>
                                            <li>Get updates about New Skills on the Block</li>
                                            <li>Upskill yourself and boost your career</li>
                                        </ul>
                                    </div>
                                    <div className="step_img mt-3">
                                        <img src={SkillLogo} className="img-fluid float_horizontal_animate" width="100%" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="modal fade show" id="skip_pop" aria-labelledby="skip_popLabel" aria-modal="true" role="dialog">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className="brife">
                                <h4>LEAVING ALREADY?</h4>
                                <p>Your skill details opens new windows enriches your profile!</p>
                            </div>
                            <div className="img_pop">
                                <img src={PopUpImg} alt="" />
                            </div>
                        </div>

                        <div className="modal-footer">
                            <button
                                className="btn btn-goback"
                                data-bs-target="#exampleModalToggle"
                                data-bs-toggle="modal"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                    document.getElementsByClassName('modal').item(0)?.setAttribute('style', 'display:none');
                                }}>
                                GO BACK
                            </button>
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    sessionStorage.setItem('user-status-code', 'ACTIVE');
                                    document.getElementById('updateUserStatusCode')?.click();
                                    navigate('/alumni/dashboard');
                                }}
                                className="btn btn-later">
                                I'LL DO THIS LATER
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AlumniSkillLayout;
